module.exports = __webpack_public_path__ + "img/JOC_3571.8be602ae.jpg";